module.exports = __webpack_public_path__ + "static/media/farm_bio.a3cc3a2f.pdf";